<template>
    <!-- 主容器 -->
    <div class="yx-div">
        <!-- 工具栏-->
        <div class="yx-div-top">
            <div class="yx-flex-h-between">
                <div class="yx-flex-h-start2">
                    <div>
                        检索条件：
                        <el-input size="mini" placeholder="查询内容" v-model="searchVal.keyword" clearable class="input-with-select" style="width: 400px">
                            <el-select size="mini" v-model="searchVal.keywordMethod" slot="prepend" placeholder="选择关键字" class="el-select-with-input">
                                <el-option v-for="item in keywordList" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-input>
                    </div>
                    <el-tooltip content="清空查询条件"><i class="el-icon-circle-close cls-refresh" @click="searchReset"/></el-tooltip>
                </div>
                <div>
                    <el-button icon="el-icon-search" type="primary" @click="searchDo">查询</el-button>
                    <el-button type="warning" @click="showFV = !showFV"> <i :class="showFV?'fa fa-angle-double-up':'fa fa-angle-double-down'" aria-hidden="true" /> </el-button>
                </div>
            </div>
            <div v-show="showFV" >
            </div>
        </div>
        <!-- 数据栏 -->
        <div class="yx-div-center">
            <!-- 数据表 -->
            <el-table
                    :data="jnl"
                    border
                    :header-cell-style="{background:'#fafafa'}"
                    v-loading="loading"
                    :cell-class-name="addClass"
                    height="100%"
                    style="width: 100%;">
                <el-table-column
                        type="index"
                        width="50">
                </el-table-column>
                <el-table-column prop="devInfo.terSn" label="设备SN" width="210" />
                <el-table-column prop="devInfo.modelId" label="型号" width="80" >
                    <template slot-scope="scope">
                        {{getModelNameById(scope.row.devInfo.modelId)}}
                    </template>
                </el-table-column>
                <el-table-column prop="devInfo.inAgentName" label="设备归属" width="80" show-overflow-tooltip />
                <el-table-column prop="devInfo.inMchName" label="当前商户" width="180" show-overflow-tooltip />
                <el-table-column prop="mall" label="点亮" align="center" width="100" sortable >
                    <template slot-scope="scope">
                        <div class="yx-flex-h-between">
                            <div></div>
                            {{scope.row.mall}}
                            <div><i class="el-icon-s-flag" v-if="scope.row.mall>=50"/></div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="m202007" label="12月" align="center" width="100" sortable />
                <el-table-column prop="m202008" label="01月" align="center" width="100" sortable />
                <el-table-column prop="m202009" label="02月" align="center" width="100" sortable />
                <el-table-column prop="m202010" label="03月" align="center" width="100" sortable />
                <el-table-column prop="m202011" label="04月" align="center" width="100" sortable />
                <el-table-column prop="m202012" label="05月" align="center" width="100" sortable />

                <!--
                <el-table-column fixed="right" label="达标状态" width="170" align="center" >
                    <template slot-scope="scope">
                        <el-rate :max="6" allow-half="true" :value="fmtRate(scope.row)" />
                    </template>
                </el-table-column>
                -->

            </el-table>

        </div>

        <!-- 分页栏 -->
        <div class="yx-flex-h-between">
            <div style="height:32px;line-height: 32px; font-family: 'Arial Black'; font-size: 15px; background-color:green; color: white; padding-left: 15px;padding-right: 15px; ">{{msgInfo}}</div>
            <!--
            <el-button type="success" @click="exportData" icon="el-icon-download" plain>导出</el-button>
            -->
            <div class="yx-flex-h-end">
                <el-pagination
                        :current-page.sync="page"
                        @current-change="currentChange"
                        @size-change="sizeChange"
                        layout="sizes, prev,pager,next, jumper,->, total, slot"
                        :total="total">
                </el-pagination>
            </div>
        </div>

    </div>

</template>

<script>
    export default {
        name: "RptDevActTot", //服务商刷脸设备活动进度 【自然月】
        data() {
            return {
                loading: false,
                showFV: false,
                total: 0,
                msgInfo: 0,
                page: 1,
                size: 10,
                jnl: [],
                keywordList: [
                    {id:"devInfo.terSn",name:"设备序列号"},
                ],
                searchVal: {
                    keywordMethod: '',
                    keyword: '',
                    totalTypes : [],
                    payWayCode : null,
                    payModeCode : null,
                    transDateScope : null,
                    minAmount: null,
                    maxAmount: null
                },
            }
        },
        mounted() {
            this.initJnl();
        },
        methods: {
            searchReset() {
                this.searchVal = {};
                this.searchVal.totalTypes = [];
            },
            searchDo() {
                this.page = 1;
                this.initJnl();
            },
            initJnl() {
                this.loading = true;
                let url = '/rpt/agent/wxActDevFaceTotals_ZRY?page=' + this.page + '&size=' + this.size;
                if (this.searchVal.totalTypes)
                    url += '&totalTypes=' + this.searchVal.totalTypes;
                if (this.searchVal.keywordMethod && this.searchVal.keyword)
                    url += '&'+this.searchVal.keywordMethod+'=' + this.searchVal.keyword;
                if (this.searchVal.payWayCode)
                    url += '&payWayCode=' + this.searchVal.payWayCode;
                if (this.searchVal.payModeCode)
                    url += '&payModeCode=' + this.searchVal.payModeCode;
                if (this.searchVal.transDateScope)
                    url += '&transDateScope=' + this.searchVal.transDateScope;
                if (this.searchVal.minAmount)
                    url += '&minAmount=' + this.searchVal.minAmount;
                if (this.searchVal.maxAmount)
                    url += '&maxAmount=' + this.searchVal.maxAmount;

                this.getRequest(url).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.jnl = resp.data;
                        this.total = resp.total;
                        this.msgInfo = resp.msgInfo;
                    }
                });
            },
            exportData() {

                let url = '';//'/rpt/comp/mch/wxActDevFaceTotals_ZRY/export?page=1';
                if (this.searchVal.totalTypes)
                    url += '&totalTypes=' + this.searchVal.totalTypes;
                if (this.searchVal.keywordMethod && this.searchVal.keyword)
                    url += '&'+this.searchVal.keywordMethod+'=' + this.searchVal.keyword;
                if (this.searchVal.payWayCode)
                    url += '&payWayCode=' + this.searchVal.payWayCode;
                if (this.searchVal.payModeCode)
                    url += '&payModeCode=' + this.searchVal.payModeCode;
                if (this.searchVal.transDateScope)
                    url += '&transDateScope=' + this.searchVal.transDateScope;
                if (this.searchVal.minAmount)
                    url += '&minAmount=' + this.searchVal.minAmount;
                if (this.searchVal.maxAmount)
                    url += '&maxAmount=' + this.searchVal.maxAmount;


                window.open(url, '_parent');

            },
            funFmtTransAmt(row, column) {
                return row.amount.toFixed(2);
            },
            funFmtTemp(row, column) {
                return '0.00';
            },
            // 日期格式化
            funDateFormatter (row, column) {
                let tm = row.paySuccTime;
                if(tm && tm.length===19) {
                    tm = tm.substring(0,10);
                }
                return tm;
            },
            // 时间格式化
            funTimeFormatter (row, column) {
                let tm = row.paySuccTime;
                if(tm && tm.length===19) {
                    tm = tm.substring(11,19);
                }
                return tm;
            },
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initJnl();
            },
            currentChange(currentPage) {
                this.page = currentPage;
                this.initJnl();
            },
            getModelNameById(id) {
                if(this.$root.g_data_dev_model!==null) {
                    for(let i=0;i<this.$root.g_data_dev_model.length;i++) {
                        if(id===this.$root.g_data_dev_model[i].id)
                            return this.$root.g_data_dev_model[i].model;
                    }
                }
                return '未知型号';
            },
            addClass({row,column,rowIndex,columnIndex}){
                if(columnIndex === 5){
                    if(row.mall >= 50){
                        return 'cell-50';
                    }
                    if(row.mall >= 25){
                        return 'cell-25';
                    }
                }
                else if(columnIndex === 6 || columnIndex === 7 || columnIndex === 8 || columnIndex === 9 || columnIndex === 10 || columnIndex === 11){
                    if(row.mall >= 400){
                        return 'cell-50';
                    }
                    if(row.mall >= 200){
                        return 'cell-25';
                    }
                }

            },
            fmtRate(row) {
                const DB = 400;
                let t1 = 0;
                let t2 = 0;
                let t3 = 0;

                t1 = row.mall>=50?1:0;

                if(row.m202007>=DB||row.m202008>=DB||row.m202009>=DB||row.m202010>=DB||row.m202011>=DB||row.m202012>=DB) {
                    t2 = 1;
                }

                let cnt=0;
                let xa = [row.m202007,row.m202008,row.m202009,row.m202010,row.m202011,row.m202012];
                xa.forEach(item => {
                    if(item>=DB) {
                        cnt++;
                    }
                });
                // 最后一个月200就够了。暂时以400计算。后面再改。
                if(cnt>=3) {
                    t3 = 1;
                }

                return t1+cnt;
            }
        }
    }
</script>

<style>
    .cell-25 {
        font-weight: bolder;
        font-size: 15px;
        color: orange;
    }
    .cell-50 {
        font-weight: bolder;
        font-size: 20px;
        color: red;
    }
    .cell-over {
        font-weight: bolder;
        font-size: 25px;
        color: green;
    }
</style>
